import type { TournamentData } from '../../Platform';
import { FakeOverlayTemplate } from '../FakeOverlayTemplate';

export function openFakeTournamentShareDialog(
  score: number,
  tournamentData: TournamentData,
  payload?: object,
): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    const ui = new FakeOverlayTemplate()
      .addText('SHARE TOURNAMENT')
      .addText(`score: ${score}`)
      .addObject(tournamentData)
      .addObject(payload ?? {})
      .addButton('SHARE', () => {
        resolve(true);
        ui.destroy();
      })
      .addButton('CLOSE', () => {
        resolve(true);
        ui.destroy();
      });
  });
}
